// Sidebar nav + outlet for the admin sub-app. Renders a small
// vertical nav with links to each admin page and a <Switch> for the
// inner routes.

import React from 'react';
import { NavLink, Route, Switch } from 'react-router-dom';

import Overview from './pages/Overview';
import Users from './pages/Users';
import UserDetail from './pages/UserDetail';
import Subscriptions from './pages/Subscriptions';
import Engagement from './pages/Engagement';
import ContentConversations from './pages/ContentConversations';
import ContentConversation from './pages/ContentConversation';
import ChapterContent from './pages/ChapterContent';
import MiniCourses from './pages/MiniCourses';
import MiniCourseDetail from './pages/MiniCourseDetail';
import Speakers from './pages/Speakers';

const SECTIONS = [
    { to: '/admin', exact: true, label: 'Overview' },
    { to: '/admin/users', label: 'Users' },
    { to: '/admin/subscriptions', label: 'Subscriptions' },
    { to: '/admin/engagement', label: 'Engagement' },
    { to: '/admin/content', label: 'Content' },
    { to: '/admin/chapter-content', label: 'Chapter intros' },
    { to: '/admin/mini-courses', label: 'Mini courses' },
    { to: '/admin/speakers', label: 'Voice settings' },
];

export default function AdminLayout() {
    return (
        <div style={styles.shell}>
            <aside style={styles.sidebar}>
                <div style={styles.brand}>Italian Naturally</div>
                <div style={styles.sub}>Admin console</div>
                <nav style={styles.nav}>
                    {SECTIONS.map((s) => (
                        <NavLink
                            key={s.to}
                            to={s.to}
                            exact={s.exact}
                            style={styles.link}
                            activeStyle={styles.linkActive}
                        >
                            {s.label}
                        </NavLink>
                    ))}
                </nav>
            </aside>
            <main style={styles.main}>
                <Switch>
                    <Route path="/admin" exact component={Overview} />
                    <Route path="/admin/users/:id" component={UserDetail} />
                    <Route path="/admin/users" component={Users} />
                    <Route path="/admin/subscriptions" component={Subscriptions} />
                    <Route path="/admin/engagement" component={Engagement} />
                    <Route path="/admin/content/conversations/:id" component={ContentConversation} />
                    <Route path="/admin/content" component={ContentConversations} />
                    <Route path="/admin/chapter-content" component={ChapterContent} />
                    <Route path="/admin/mini-courses/:id" component={MiniCourseDetail} />
                    <Route path="/admin/mini-courses" component={MiniCourses} />
                    <Route path="/admin/speakers" component={Speakers} />
                </Switch>
            </main>
        </div>
    );
}

const styles = {
    shell: { display: 'flex', minHeight: '100vh', backgroundColor: '#faf6f2', fontFamily: '-apple-system, system-ui, sans-serif' },
    sidebar: {
        width: 220,
        backgroundColor: '#222',
        color: '#fff',
        padding: '24px 16px',
        boxSizing: 'border-box',
    },
    brand: { fontSize: 16, fontWeight: 700, color: '#d97447' },
    sub: { fontSize: 12, color: '#aaa', marginTop: 2, marginBottom: 24 },
    nav: { display: 'flex', flexDirection: 'column', gap: 4 },
    link: {
        color: '#ddd',
        textDecoration: 'none',
        padding: '8px 10px',
        borderRadius: 6,
        fontSize: 14,
    },
    linkActive: { backgroundColor: '#d97447', color: '#fff', fontWeight: 600 },
    main: { flex: 1, padding: '24px 32px', overflow: 'auto' },
};
